module.exports = __webpack_public_path__ + "icomoon.9baf34ff20b1e790db31.svg";


//////////////////
// WEBPACK FOOTER
// G:/UTL/BMI/Admin/Admin-ANG/src/assets/fonts/icomoon.svg?mm9zby
// module id = ../../../../../src/assets/fonts/icomoon.svg?mm9zby
// module chunks = styles